import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;

/**
 * 组织人员管理 API 服务
 */
export const userService = {
  /**
   * 分页查询人员列表
   * @param {Object} params { userName, tel, pageNo, pageSize }
   */
  queryPage: (params) => axios.get(`${iffApi}/org/user/page`, { params }),

  /**
   * 查询人员详情（含已关联岗位，用于编辑回显）
   * @param {String} userCode 用户编码
   */
  getDetail: (userCode) => axios.get(`${iffApi}/org/user/detail/${userCode}`),

  /**
   * 查询本部门可选岗位列表（供岗位多选框使用）
   */
  getDeptRoles: () => axios.get(`${iffApi}/org/user/roles`),

  /**
   * 新增人员
   * @param {Object} data { userName, account, tel, idNum, roleCodes, pwd? }
   */
  saveUser: (data) => axios.post(`${iffApi}/org/user/save`, data),

  /**
   * 编辑人员信息
   * @param {Object} data { userCode, userName, tel, idNum, roleCodes }
   */
  updateUser: (data) => axios.put(`${iffApi}/org/user/update`, data),

  /**
   * 删除人员（软删除）
   * @param {String} userCode 用户编码
   */
  deleteUser: (userCode) => axios.delete(`${iffApi}/org/user/delete/${userCode}`)
};
